import React from "react";
import { StyledForm, paddingStyle } from "./style.module";
import {DatePicker} from 'antd';
import { FormMandatoryIcon } from "./FormMandatoryIcon";
import { Col } from "react-bootstrap";
import dayjs from 'dayjs';

export const FormDate = ({
  id,
  elementkey,
  isMandatory,
  label,
  error,
  onSelect
}) => {
  const disabledDate = (current) => {
    // Can not select days before today
    return current < dayjs().startOf('day');
  };
  return (
    <StyledForm.Group
      as={Col}
      lg="4"
      controlId={id}
      style={paddingStyle}
      key={elementkey}
    >
      <StyledForm.Label>
        {isMandatory && <FormMandatoryIcon />}
        {label}
      </StyledForm.Label>
      <DatePicker
        style={{ width: '100%' }}
        format="DD/MM/YYYY"
        onChange={onSelect}
        disabledDate={disabledDate}
      />
      {error && (
        <div style={{ color: "#DC3545", fontSize: "0.700rem", marginTop: "0.25rem" }}>
          {error}
        </div>
      )}
    </StyledForm.Group>
  );
};
